__webpack_require__.p = "/sidebar-expander-shortcuts/referrals-hub/";